import i18n from "i18next"
import Backend from "i18next-xhr-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "pl",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json"
    },
    debug: false,
    // interpolation: {
    //   escapeValue: false, // not needed for react!!
    // },

    react: {
      wait: true,
      useSuspense: false,
    },
    parseMissingKeyHandler : () => "",
  }
);

export default i18n
